import { Action, createReducer, on } from "@ngrx/store";

import { worldActions } from "./world.actions";
import { initialState, WorldState } from "./world.state";

export const worldReducer = createReducer(
  initialState,
  on(worldActions.threeRendererReady, (state, { viewId }) => ({
    ...state,
    threeRendererReady: true,
  })),
  on(worldActions.pixiRendererReady, (state, { viewId }) => ({
    ...state,
    pixiRendererReady: true,
  })),
  on(worldActions.surfacesReady, (state, { viewId }) => ({
    ...state,
    surfacesReady: true,
  })),
  on(worldActions.binstViewReady, (state, { viewId }) => ({
    ...state,
    binstViewReady: true,
  })),
  on(worldActions.surfaceDebuggingToggled, (state, { enabled }) => ({
    ...state,
    surfaceDebug: enabled,
  })),
  on(worldActions.timerTicked10s, (state, { currentTick }) => ({
    ...state,
    tickCount: currentTick,
  })),
  on(worldActions.setDebugValue, (state, { key, value }) => ({
    ...state,
    debuggers: {
      ...state.debuggers,
      [key]: value,
    },
  }))
);
